/* SectionCard — shared "tinted card with uppercase tracking-[0.2em] label
 * + optional Phosphor icon" rhythm used across the case detail surfaces.
 *
 * Originally lived inline at the bottom of CaseDetail.jsx for the
 * Submission tab brief. Pulled out so the Treatment Plan tab (and any
 * future surface) can render with the exact same visual cadence —
 * keeping the case detail page reading as one consistent piece.
 *
 * Pure presentational. No state, no side-effects. Functionally
 * identical to the original module-scope `Section` helper.
 */
import React from "react";

export default function SectionCard({ icon: Icon, label, children, testid, className = "" }) {
    return (
        <section
            className={`rounded-xl border border-border/70 bg-secondary/15 px-4 py-3.5 space-y-3 ${className}`}
            data-testid={testid}
        >
            {label != null && (
                <div className="flex items-center gap-2 text-[10px] font-bold tracking-[0.2em] uppercase text-primary/85">
                    {Icon ? <Icon size={12} weight="duotone" /> : null}
                    {label}
                </div>
            )}
            <div>{children}</div>
        </section>
    );
}
